import { h, render } from "preact";
import { RelatedArticlesContainer, type RelatedArticlesContainerProps } from "./related-articles-container";

const BootstrapRelatedArticles = (): void => {
  const listcontainerElement = document.querySelector<HTMLElement>(".related-articles-block");
  if (!listcontainerElement) return;

  const props: RelatedArticlesContainerProps = {
    pageIdList: listcontainerElement.dataset.pageids,
    showIngress: listcontainerElement.dataset.showLead === "True",
    relatedTitle: listcontainerElement.dataset.relatedTitle,
  };
  render(h(RelatedArticlesContainer, props), listcontainerElement);
};

BootstrapRelatedArticles();
